import axios                            from "axios"
import Vue                              from "vue"
import { i18n }                         from "../i18n/i18n.js"

const state = {
    catalogs : [],
    article: null,
    sourceLang: "master",
    targetLang: "en",
    languages: { master:["Source", {}], en: ["English", {}]},
    vartext: [],
    pid2trus:{},
    t9n_tags: [],
    changes: {},
    changeCount: 0,
    saveInProgress: true
}

const mutations = {
    genericSet (state, payload) {
        state [payload.key] = payload.data
    },
    changeTranslation (state, {tid, value}) {
        let ltr = state.languages [state.targetLang] [1]
        let lch = state.changes   [state.targetLang]
        if (!(tid in lch)) {
            Vue.set (lch, tid, ltr [ltr] || "")
            state.changeCount = state.changeCount + 1
        } else if (lch [tid] === value) {
            Vue.delete (lch, tid)
            state.changeCount = state.changeCount - 1
        }
        Vue.set (ltr, tid, value || undefined)
    },
    addLanguages (state, tid) {
        for (const key in tid) {
            let val = tid [key]
            if (key in state.languages) {
                Object.assign (val [1], state.languages [key] [1])
            }
            Vue.set (state.languages, key, val)
            if (!(key in state.changes)) {
                Vue.set (state.changes, key, {})
            }
        }
    },
    changeSourceLang (state, lang) {
        state.sourceLang = lang
    },
    changeTargetLang (state, lang) {
        state.targetLang = lang
    },
    setSaveInProgress (state, value) {
        state.saveInProgress = value
    },
    clearChanges (state) {
        state.changes     = {}
        for (let l of Object.keys (state.languages)) {
            Vue.set (state.changes, l, {})
        }
        state.changeCount = 0
    },
    setT9nTags (state, tags) {
        state.t9n_tags = tags
    },
    setVartext (state, {vartext, pid2trus}) {
        state.vartext  = vartext
        state.pid2trus = pid2trus
    },
    clearVartext (state) {
        state.vartext  = []
        state.pid2trus = {}
    }
}

const actions = {
    loadCatalogs ({commit, rootGetters}, {self}) {
        return axios.get ("/vue/i18n/catalog/", {
            headers: { Authorization: "Token " + rootGetters.getUserToken }
          }).
            then ((data) => {
                let pl = data.data
                if (pl.status) {
                    commit ("genericSet", {key : "catalogs", data: pl.catalogs})
                    commit ("addLanguages", pl.tid)
                } else {
                    self.$toastr("error", pl.error, i18n.t("error"))
                }
            })
    },
    loadArticle ({commit, state, rootGetters}, {model, id, self}) {
        commit ("genericSet", {key : "article", data: null})
        axios.get (`/vue/i18n/article/${id}/${model}/`,
            { params: {lang: state.targetLang},
            headers: { Authorization: "Token " + rootGetters.getUserToken }
        }).
            then ((data) => {
                let pl = data.data
                if (pl.status) {
                    commit ("genericSet", {key : "article", data: data.data.article})
                    commit ("addLanguages", pl.tid)
                    commit ("setT9nTags", pl.global_t9ntags)
                } else {
                    self.$toastr("error", pl.error, i18n.t("error"))
                }
            })
    },
    saveChanges ({commit, state}, {vartext, self}) {
        commit ("setSaveInProgress", true)
        if (state.changeCount) {
            let url = "/vue/i18n/save/"
            if (vartext) url = "/vue/i18n/vartext/"
            axios.post (url, {
                languages : state.languages,
                changes: state.changes,
                pid2trus: state.pid2trus
            }).then (resp => {
                commit ("setSaveInProgress", false)
                if (resp.data.status) {
                    commit ("clearChanges")
                } else {
                    self.$toastr("error", resp.data.error, i18n.t("error"))
                }
            })
        }
    },
    loadVartext ({commit, state, rootGetters}, {self}) {
        axios.get (`/vue/i18n/vartext/`,
            { params: {src: state.sourceLang, dst: state.targetLang},
            headers: { Authorization: "Token " + rootGetters.getUserToken }
        }).
            then ((data) => {
                let pl = data.data
                if (pl.status) {
                    commit ("setVartext",   {vartext: pl.vartext, pid2trus: pl.pid2trus})
                    commit ("addLanguages", pl.tid)
                    commit ("setT9nTags",   pl.t9n_tags)
                } else {
                    self.$toastr("error", pl.error, i18n.t("error"))
                }
            })
    },

}

const getters = {
    tid () {
        return state.languages ["master"] [1]
    },
    targetTr (state) {
        return state.languages [state.targetLang] [1]
    },
    targetName (state) {
        return state.languages [state.targetLang] [0]
    },
    sourceName (state) {
        return state.languages [state.sourceLang] [0]
    },
    possibleSources (state) {
        let result = []
        for (let key in state.languages) {
            if (  ((key != state.targetLang) && state.languages [key] [2])
               || (key == "master")
               )
                result.push ([key, state.languages [key] [0]])
            else {
                console.log ("Ignore Source lang", key, state.languages [key] [2], state.languages [key])
            }
        }
        return result
    },
    possibleTargets (state) {
        let result = []
        for (let key in state.languages) {
            if (  (key != state.sourceLang)
               && (key != "master")
               && state.languages [key] [3]
               )
                result.push ([key, state.languages [key] [0]])
        }
        return result
    },
    totalTranslated (state) {
        let translated = 0
        const trLang = state.languages [state.targetLang] [1]
        for (const key of state.t9n_tags) {
            if (key in trLang) translated += 1
        }
        return translated
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
  }